import type { ServiceKey } from '../content/types'

/**
 * The seven services, in the order they appear in the navigation, in the
 * services grid and in the sitemap. `SERVICE_KEYS` is the single source of
 * iteration order; routes, JSON-LD and the services showcase all read it.
 */
export const SERVICE_KEYS: readonly ServiceKey[] = [
  'rifacimento',
  'giardinaggio',
  'secondeCase',
  'condomini',
  'irrigazione',
  'treeClimbing',
  'fresatura',
]

/**
 * Per-locale URL segment. These strings are the public URLs: changing one
 * after cutover breaks links and rankings, so treat them as frozen.
 */
export const SERVICE_SLUGS: Record<ServiceKey, { it: string; en: string }> = {
  irrigazione:  { it: 'irrigazione-smart',     en: 'smart-irrigation' },
  secondeCase:  { it: 'seconde-case',          en: 'second-homes' },
  condomini:    { it: 'condomini',             en: 'condominiums' },
  rifacimento:  { it: 'rifacimento-giardini',  en: 'garden-renovation' },
  giardinaggio: { it: 'giardinaggio',          en: 'gardening' },
  treeClimbing: { it: 'tree-climbing',         en: 'tree-climbing' },
  fresatura:    { it: 'fresatura-ceppi',       en: 'stump-grinding' },
}

/** Photo role (media/manifest.json) used by each service hero. */
export const SERVICE_MEDIA_ROLE: Record<ServiceKey, string> = {
  irrigazione: 'irrigazione',
  secondeCase: 'seconde-case',
  condomini: 'borgosesia',
  rifacimento: 'rifacimento',
  giardinaggio: 'giardinaggio',
  treeClimbing: 'climbing',
  fresatura: 'fresatura',
}

/** Detail-block photo: the hero's photo on every service page. */
export const SERVICE_DETAIL_ROLE: Record<ServiceKey, string> = { ...SERVICE_MEDIA_ROLE }

/**
 * "Related services" shown at the foot of each service page — three keys,
 * never the page's own key, ordered by how often the two are bought together.
 */
export const RELATED_SERVICES: Record<ServiceKey, readonly [ServiceKey, ServiceKey, ServiceKey]> = {
  irrigazione:  ['secondeCase', 'rifacimento', 'giardinaggio'],
  secondeCase:  ['irrigazione', 'giardinaggio', 'treeClimbing'],
  condomini:    ['giardinaggio', 'irrigazione', 'treeClimbing'],
  rifacimento:  ['irrigazione', 'fresatura', 'giardinaggio'],
  giardinaggio: ['secondeCase', 'condomini', 'treeClimbing'],
  treeClimbing: ['fresatura', 'giardinaggio', 'secondeCase'],
  fresatura:    ['treeClimbing', 'rifacimento', 'giardinaggio'],
}
